import { useCurrentStateAndParams } from '@uirouter/react';
import { Code } from 'lucide-react';

import { PageHeader } from '@@/PageHeader';
import { Widget } from '@@/Widget/Widget';
import { WidgetBody } from '@@/Widget';
import { WidgetTabs, Tab, useCurrentTabIndex } from '@@/Widget/WidgetTabs';

import { YAMLInspector } from '../../components/YAMLInspector';

import { useCustomResourceDefinition } from './queries/useCustomResourceDefinition';

export function CustomResourceDefinitionDetailsView() {
  const {
    params: { endpointId: environmentId, name },
  } = useCurrentStateAndParams();

  const {
    data: yamlData,
    isLoading: isYamlLoading,
    isError: isYamlError,
  } = useCustomResourceDefinition(environmentId, name, { yaml: true });

  const tabs: Tab[] = [
    {
      name: 'YAML',
      icon: Code,
      widget: (
        <div className="row">
          <div className="col-sm-12">
            <Widget>
              <WidgetBody>
                <YAMLInspector
                  identifier="crd-yaml"
                  data={yamlData?.toString() || ''}
                  authorised
                  system={false}
                  hideMessage
                  isLoading={isYamlLoading}
                  isError={isYamlError}
                  data-cy="crd-yaml"
                />
              </WidgetBody>
            </Widget>
          </div>
        </div>
      ),
      selectedTabParam: 'yaml',
    },
  ];

  const currentTabIndex = useCurrentTabIndex(tabs);

  if (!yamlData) {
    return null;
  }

  return (
    <>
      <PageHeader
        title="Custom Resource Definition details"
        breadcrumbs={[
          {
            label: 'Custom Resource Definitions',
            link: 'kubernetes.moreResources.customResources',
            linkParams: { tab: 'definitions' },
          },
          name,
        ]}
        reload
      />
      <WidgetTabs tabs={tabs} currentTabIndex={currentTabIndex} />
      {tabs[currentTabIndex].widget}
    </>
  );
}
